export const C_LOCAL_STORAGE_LOCALE_LIST = 'locale_list'
export const C_LOCAL_STORAGE_LOCALE_LANG = 'locale_lang'

export const C_LOCAL_STORAGE_GEO_USER = 'geo_user'
